import React from 'react';

import { Skeleton, SkeletonRow } from '@components/skeleton';
import SkeletonDivDefault from '@components/skeleton/SkeletonDivDefault';

import ContactPersonCardSkeleton from './components/job-overview/ContactPersonCardSkeleton';

const SkeletonRowLgInfo = () => (
  <div className='flex w-full flex-row'>
    <div className='mt-4 h-8 w-full'>
      <SkeletonRow className='w-4/5' />
    </div>
    <div className='mt-4 h-8 w-full'>
      <SkeletonRow className='w-4/5' />
    </div>
  </div>
);

const JobOverviewSkeletonLg = () => (
  <>
    <div className='mt-4 flex justify-between border-b border-gray-200 pb-4'>
      <div className='w-2/3'>
        <SkeletonRowLgInfo />
      </div>
      <div className='mt-4 flex h-8 w-1/3 justify-end p-0'>
        <SkeletonRow className='w-2/5' />
      </div>
    </div>
    <div className='mt-6 flex w-full flex-row border-b border-gray-200 pb-6'>
      <div className='flex w-3/5 flex-col gap-4 border-r pr-6'>
        <SkeletonRowLgInfo />
        <SkeletonRowLgInfo />
        <SkeletonRowLgInfo />
      </div>
      <div className='w-2/5 pl-6'>
        <ContactPersonCardSkeleton />
      </div>
    </div>
    <div>
      <div className='mt-4 flex h-8 w-full flex-row'>
        <SkeletonRow className='mr-12 w-1/6' />
        <SkeletonRow className='mr-12 w-1/6' />
        <SkeletonRow className='mr-12 w-1/6' />
        <SkeletonRow className='mr-12 w-1/6' />
        <SkeletonRow className='mr-12 w-1/6' />
      </div>
    </div>
  </>
);

export const JobOverviewSkeletonSm = () => (
  <>
    <Skeleton className='mb-4 h-[72px] pl-6'>
      <SkeletonDivDefault className='w-1/3' />
    </Skeleton>
    <Skeleton className='h-[670px] pl-6'>
      <SkeletonDivDefault className='mt-1 w-1/3' />
      <SkeletonDivDefault className='w-1/2' />
      <SkeletonDivDefault className='w-1/5' />
      <SkeletonDivDefault className='w-1/3' />
      <SkeletonDivDefault className='w-2/5' />
      <SkeletonDivDefault className='w-1/5' />
      <SkeletonDivDefault className='w-1/2' />
      <SkeletonDivDefault className='w-2/5' />
      <SkeletonDivDefault className='w-1/5' />
      <SkeletonDivDefault className='w-2/3' />
      <SkeletonDivDefault className='w-1/3' />
      <SkeletonDivDefault className='w-2/5' />
      <SkeletonDivDefault className='w-1/5' />
    </Skeleton>
  </>
);

export const JobOverviewSkeleton = () => (
  <>
    <div className='lg:hidden'>
      <JobOverviewSkeletonSm />
    </div>
    <div className='hidden lg:block'>
      <Skeleton className='flex h-[530px] px-12'>
        <JobOverviewSkeletonLg />
      </Skeleton>
    </div>
  </>
);

export const ContainerSectionSkeleton = () => (
  <>
    <div className='mx-6 lg:hidden'>
      <Skeleton className='mt-6 mb-6 h-[128px]'>
        <SkeletonDivDefault className='ml-6 w-7/12' />
        <div className='pr-6'>
          <div className='mt-4 h-8 w-full pr-6'>
            <SkeletonRow className='ml-6 w-full md:w-1/6' />
          </div>
        </div>
      </Skeleton>
      <JobOverviewSkeletonSm />
    </div>
    <section className='mx-auto hidden w-full px-6 lg:container lg:block 2xl:max-w-7xl'>
      <Skeleton className='flex h-[625px] px-12'>
        <div className='mt-4 flex justify-between pb-4'>
          <div className='mt-4 h-8 w-full'>
            <SkeletonRow className='w-3/5' />
          </div>
          <div className='mt-4 h-8 w-full'>
            <SkeletonRow className='col-span-2 w-full' />
          </div>
        </div>
        <JobOverviewSkeletonLg />
      </Skeleton>
    </section>
  </>
);
